"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useKeyStrokes: true
};
exports.useKeyStrokes = exports.default = void 0;
var _react = require("react");
var _isFunction = require("./isFunction");
var _useKeyStrokes = require("./useKeyStrokes.types");
Object.keys(_useKeyStrokes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useKeyStrokes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useKeyStrokes[key];
    }
  });
});
/**
 * React hook to manage keystroke state and reset after timeout
 * @returns keyStrokes and setKeyStrokes methods
 */
const KEYSTROKE_TIMEOUT = 500;
const useKeyStrokes = ({
  onKeyStrokes,
  keyStrokeTimeout = 500
}) => {
  const [keyStrokes, setKeyStrokes] = (0, _react.useState)('');
  const keyTimer = (0, _react.useRef)(null);
  const timeoutValue = typeof keyStrokeTimeout === 'number' && keyStrokeTimeout >= 0 ? keyStrokeTimeout : KEYSTROKE_TIMEOUT;
  const startTimer = () => {
    if ((0, _isFunction.isFunction)(setTimeout)) {
      keyTimer.current = setTimeout(() => {
        setKeyStrokes('');
      }, timeoutValue);
    }
  };
  const resetTimer = () => {
    if ((0, _isFunction.isFunction)(clearTimeout) && keyTimer.current !== null) {
      clearTimeout(keyTimer.current);
    }
  };
  (0, _react.useEffect)(() => {
    resetTimer();
    if (keyStrokes === null || keyStrokes === void 0 ? void 0 : keyStrokes.trim()) {
      onKeyStrokes === null || onKeyStrokes === void 0 ? void 0 : onKeyStrokes(keyStrokes);
      startTimer();
    }
    return resetTimer;
  }, [keyStrokes]);
  return {
    keyStrokes,
    setKeyStrokes
  };
};
exports.useKeyStrokes = useKeyStrokes;
var _default = exports.default = useKeyStrokes;